"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { useScrollReveal } from "@/hooks/use-scroll-reveal";
import { useSiteFlavor } from "@/components/layout/site-flavor-provider";
import posthog from "posthog-js";

export function LandingFooter() {
  const t = useTranslations("landing");
  const { isGetmint } = useSiteFlavor();
  const ref = useScrollReveal<HTMLElement>({ animation: "fade-in" });

  return (
    <footer className="border-t border-landing-border py-8" ref={ref}>
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-6 sm:flex-row">
        <span className="text-sm text-landing-muted">&copy; 2025 Mint AI</span>
        <div className="flex gap-6">
          {!isGetmint && (
          <a
            href="https://t.me/mintai_content_bot"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => posthog.capture("landing_click", { element: "footer_telegram" })}
            className="text-sm text-landing-muted transition-colors hover:text-ink"
          >
            {t("footer.telegramBot")}
          </a>
          )}
          <Link
            href="/privacy"
            onClick={() => posthog.capture("landing_click", { element: "footer_privacy" })}
            className="text-sm text-landing-muted transition-colors hover:text-ink"
          >
            {t("footer.privacy")}
          </Link>
          <Link
            href="/terms"
            onClick={() => posthog.capture("landing_click", { element: "footer_terms" })}
            className="text-sm text-landing-muted transition-colors hover:text-ink"
          >
            {t("footer.terms")}
          </Link>
        </div>
      </div>
    </footer>
  );
}
